import { Routes } from '@angular/router';
import { Utils } from '@app/shared/helpers/utils';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard
} from 'viggo-sistemas-core-web';

export const routesAdminFinanceiro: Routes = [
  {
    path: 'formas-pagamento',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_FORMA_PAGTO',
      preload: false,
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'VENDAS'),
      breadcrumb: {
        label: 'Forma pagamento',
        icon: 'mdi mdi-credit-card-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/forma-pagamento/forma-pagamento.module').then(
        m => m.FormaPagamentoModule
      )
  },
  {
    path: 'condicao-pagamento',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_COND_PAGTO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'VENDAS'),
      preload: false,
      breadcrumb: {
        label: 'Condição de pagamento',
        icon: 'mdi mdi-cash-multiple'
      }
    },
    loadChildren: () =>
      import('@app/modules/condicao-pagamento/condicao-pagamento.module').then(
        m => m.CondicaoPagamentoModule
      )
  },
  {
    path: 'contas-receber',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_CONTA_RECEBER',
      breadcrumbMenu: Utils.getBreadcrumbMenu('FINANCEIRO'),
      preload: false,
      breadcrumb: {
        label: 'Contas a receber',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/contas-receber/contas-receber.module').then(
        m => m.ContasReceberModule
      )
  },
  {
    path: 'contas-pagar',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_CONTA_PAGAR',
      breadcrumbMenu: Utils.getBreadcrumbMenu('FINANCEIRO'),
      preload: false,
      breadcrumb: {
        label: 'Contas a pagar',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/contas-pagar/contas-pagar.module').then(
        m => m.ContasPagarModule
      )
  },
  {
    path: 'portadores',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_PORTADOR',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'FINANCEIRO'),
      preload: false,
      breadcrumb: {
        label: 'Portadores',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/portador/portador.module').then(
        m => m.PortadorModule
      )
  },
  {
    path: 'natureza_financeiras',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_NAT_FINANCEIRA',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'FINANCEIRO'),
      preload: false,
      breadcrumb: {
        label: 'Natureza financeira',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import(
        '@app/modules/natureza_financeira/natureza_financeira.module'
      ).then(m => m.NaturezaFinanceiraModule)
  },
  {
    path: 'movimentacao_financeira',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_MOV_FINANCEIRA',
      breadcrumbMenu: Utils.getBreadcrumbMenu('FINANCEIRO'),
      preload: false,
      breadcrumb: {
        label: 'Movimentação financeira',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import(
        '@app/modules/movimentacao_financeira/movimentacao_financeira.module'
      ).then(m => m.MovimentacaoFinanceiraModule)
  },
  {
    path: 'centro_resultados',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_CENTRO_RESULTADO',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'FINANCEIRO'),
      preload: false,
      breadcrumb: {
        label: 'Centro de resultados',
        icon: 'pi pi-fw pi-money-bill'
      }
    },
    loadChildren: () =>
      import('@app/modules/centro_resultado/centro_resultado.module').then(
        m => m.CentroResultadoModule
      )
  },
  {
    path: 'forma_pagto_sefaz',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_FORMA_PAGTO_SEFAZ',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'FINANCEIRO'),
      preload: false,
      breadcrumb: {
        label: 'Forma pagamento sefaz',
        icon: 'pi pi-fw pi-credit-card'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import(
        '@app/modules/forma-pagamento-sefaz/forma-pagamento-sefaz.module'
      ).then(m => m.FormaPagamentoSefazModule)
  },
  {
    path: 'instituicoes_financeiras',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_INST_FINANCEIRA',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CADASTROS'),
      preload: false,
      breadcrumb: {
        label: 'Instituições financeiras',
        icon: 'pi pi-fw pi-building'
      },
      backend_path: '/instituicao_pagamentos'
    },
    loadChildren: () =>
      import(
        '@app/modules/instituicoes-financeiras/instituicao_financeira.module'
      ).then(m => m.InstituicaoFinanceiraModule)
  },
  {
    path: 'equipe-venda',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'FIN_EQP_VENDA',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CADASTROS'),
      preload: false,
      breadcrumb: {
        label: 'Equipe de venda',
        icon: 'mdi mdi-account-group-outline'
      }
    },
    loadChildren: () =>
      import('@app/modules/equipe-venda/equipe-venda.module').then(
        m => m.EquipeVendaModule
      )
  }
];
